module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/logo.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/nav')
      }
    }
  }), _vm._v(" "), (!_vm.showSearchTextBox) ? _c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: _vm.menuIndex === index ? 'current' : '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInNewPage(nav.url)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(nav.name)))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user",
    on: {
      "mouseenter": function($event) {
        _vm.showUserMenu = true
      },
      "mouseleave": function($event) {
        _vm.showUserMenu = false
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": _vm.avatarUrl,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.showUserMenu) ? _c('div', {
    staticClass: "user-menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-icon"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": _vm.avatarUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(this.userInfo.info.customerName))]), _vm._v(" "), _c('div', {
    staticClass: "vip"
  }, [_vm._v("VIP")])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/favorite?menuType=fabric')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Favorites')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myDesign')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Design')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myOrder')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Order')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myGarmentSample')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Development')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myFabric')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Fabric')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/wesAiCreate')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('W&S AI')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/VRChanel')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('VR Showroom')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/privateChanel')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Private Showroom')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/history')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Browsing History')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/userinfo')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Personal Center')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/setting')
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Security Setting')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/help')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Help')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.handleLoginOut
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Log Out')))])])]) : _vm._e()])])]), _vm._v(" "), (!_vm.onlyShowHeader) ? _c('div', {
    attrs: {
      "id": "crumb"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.onlyShowHeader & _vm.showHeadline) ? _c('div', {
    attrs: {
      "id": "headline"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/layout/headline/en/headline-fabric.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.onlyShowHeader & !_vm.showBanner) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.onlyShowHeader & !_vm.showBanner) ? _c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "none",
      "interval": 5000,
      "arrow": "never"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-1.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-2.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-3.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-4.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-5.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("@/assets/layout/banner/en/banner-fabric-6.jpg"),
      "alt": ""
    }
  })])], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-favorite.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-module.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-history.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-user.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-setting.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-question.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-logout.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51424b84","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerChanelMenu.vue
// module id = 513
// module chunks = 63